export default "__VITE_ASSET__ByCIWYjC__"